import Vue from 'vue';
import Vuex, { Module } from 'vuex';
import { actions } from '@/economic/store/actions.ts';
import { getters } from '@/economic/store/getters.ts';
import { mutations } from '@/economic/store/mutations.ts';
import { EconomicState } from '@/economic/store/types.ts';
import { RootState } from '@/shared/store/types.ts';

Vue.use(Vuex);

export const state: EconomicState = {
  token: undefined,
  EconomicData: undefined,
};

const namespaced: boolean = true;

export const economic: Module<EconomicState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
